import { render } from "./FinanceEducation.vue?vue&type=template&id=6aa03420&scoped=true"
import script from "./FinanceEducation.vue?vue&type=script&lang=js"
export * from "./FinanceEducation.vue?vue&type=script&lang=js"

import "./FinanceEducation.vue?vue&type=style&index=0&id=6aa03420&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa03420"]])

export default __exports__